import React, { useEffect, useState } from "react";
import { CommonButton } from "./CommonButton";
import InboxImage from "assets/svgIcons/SideNav/Inbox";
import HistoryImage from "assets//svgIcons/SideNav/History";
import SettingsImage from "assets//svgIcons/SideNav/Settings";
import DeviceImage from "assets//svgIcons/SideNav/VDU";
import NotificationImage from "assets//svgIcons/SideNav/Notification";
import { CommonHeading } from "./CommonHeading";
import { useHookstate } from "@hookstate/core";
import { useSelector } from "react-redux";
import { getFeatureSetOption, getFeaturesList } from "../../../constant";
import {
  MAP_GLOBAL_STATES,
  MESSAGE_FLEET_GLOBAL_STATES,
  MESSAGE_COUNT,
} from "globalStore/globalStore";
import {
  SubSideNavTabs,
} from "commonComponents/SideNav/subSideNav/subSideNavStyled";
import { Badge, Tooltip } from "@mui/material";
import { t } from "i18next";
import useAnnouncementsCount from "customHooks/useAnnouncementsCount";
import { GrAnnounce } from "react-icons/gr";

export const MessagesSideNav = () => {
  const { siteSettingsData, getUserRole } =
    useSelector((state) => state.commonReducers) || [];
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const { messageBadgeCount } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);
  const [showComponent, setShowComponent] = useState(true);
  const { announcementsCount } = useAnnouncementsCount();

  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if (
      (getSubnavName === "Inbox" &&
        !getFeatureSetOption(
          siteSettingsData && siteSettingsData?.Features,
          getFeaturesList().real_time_tracking
        )) ||
      getSubnavName === "History" ||
      getSubnavName === "Settings" ||
      getSubnavName === "VDU" ||
      getSubnavName === "Notifications" ||
      getSubnavName === "Announcements"
    ) {
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"));
    } else {
      if (
        !getFeatureSetOption(
          siteSettingsData && siteSettingsData?.Features,
          getFeaturesList().real_time_tracking
        )
      )
        mapSideNavTabState.set("Inbox");
      localStorage.setItem("mapSideNavTabState", "Inbox");
    }
  }, []);

  const { MessageNumber } = useHookstate(MESSAGE_COUNT);

  return (
    <div>
      {showComponent && (
        <div>
          <CommonHeading labelText={"Messages"} />
          <SubSideNavTabs>
            <Badge
              badgeContent={
                MessageNumber.get() !== 0 ? MessageNumber.get() : null
              }
              color={MessageNumber.get() !== 0 ? "error" : "default"}
            >
              {/* <span>{messageBadgeCount.get()}</span> */}
              <Tooltip title={t("Inbox")} arrow>
                <span>
                  <CommonButton
                    labelText={"Inbox"}
                    displayText={"Inbox"}
                    changeSideNavData={() => {
                      messageBadgeCount.set(0);
                      localStorage.setItem("mapSideNavTabState", "Inbox");
                      mapSideNavTabState.set("Inbox");
                    }}
                    disabled={
                      getFeatureSetOption(
                        siteSettingsData && siteSettingsData?.Features,
                        getFeaturesList().real_time_tracking
                      ) &&
                      getUserRole &&
                      getUserRole.Role != 6
                    }
                  >
                    {/* {MessageNumber.get()!=0 ?<span className="message-count">{MessageNumber.get()}</span>:""}   */}
                    <InboxImage
                      color={
                        mapSideNavTabState.get() == "Inbox"
                          ? "var(--theme-text)"
                          : "var(--text-secondary)"
                      }
                    />
                  </CommonButton>
                </span>
              </Tooltip>
            </Badge>

            <Tooltip title={t("History")} arrow>
              <span>
                <CommonButton
                  labelText={"History"}
                  displayText={"History"}
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "History");
                    mapSideNavTabState.set("History");
                  }}
                >
                  <HistoryImage
                    color={
                      mapSideNavTabState.get() == "History"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>

            <Tooltip title={t("Settings")} arrow>
              <span>
                <CommonButton
                  labelText={"Settings"}
                  displayText={"Settings"}
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "Settings");
                    mapSideNavTabState.set("Settings");
                  }}
                >
                  <SettingsImage
                    color={
                      mapSideNavTabState.get() === "Settings"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>

            <Tooltip title={t("VDU")} arrow>
              <span className="Scorecards">
                <CommonButton
                  labelText="VDU"
                  displayText="VDU"
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "VDU");
                    mapSideNavTabState.set("VDU");
                  }}
                >
                  <DeviceImage
                    color={
                      mapSideNavTabState.get() === "VDU"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>

            <Tooltip title={t("Notifications")} arrow>
              <span>
                <CommonButton
                  labelText={"Notifications"}
                  displayText={"Notifications"}
                  changeSideNavData={() => {
                    localStorage.setItem("mapSideNavTabState", "Notifications");
                    mapSideNavTabState.set("Notifications");
                  }}
                >
                  <NotificationImage
                    color={
                      mapSideNavTabState.get() === "Notifications"
                        ? "var(--theme-text)"
                        : "var(--text-secondary)"
                    }
                  />
                </CommonButton>
              </span>
            </Tooltip>

            <Badge
              badgeContent={
                announcementsCount !== 0 ? announcementsCount : null
              }
              color={announcementsCount !== 0 ? "error" : "default"}
            >
              <Tooltip title={t("Announcements")} arrow>
                <span>
                  <CommonButton
                    labelText={"Announcements"}
                    displayText={"Announcements"}
                    changeSideNavData={() => {
                      localStorage.setItem("mapSideNavTabState", "Announcements");
                      mapSideNavTabState.set("Announcements");
                    }}
                  >
                    <GrAnnounce
                      style={{width:28, height:30}}
                      color={
                        mapSideNavTabState.get() === "Announcements"
                          ? "var(--theme-text)"
                          : "var(--text-secondary)"
                      }
                    />
                  </CommonButton>
                </span>
              </Tooltip>
            </Badge>
          </SubSideNavTabs>

          {/* <Box>{sideSubnavData()}</Box> */}
        </div>
      )}
    </div>
  );
};
